/* Buffalo: busqueda precisa por titulo y SKU, con "También te puede interesar".
   Shopify ignora options[fields] en la pagina de resultados y en el predictivo, asi que el filtrado se hace aca. */
(function () {
  if (window.bfSearch) return;

  var STOP = { de: 1, del: 1, la: 1, el: 1, los: 1, las: 1, y: 1, para: 1, con: 1, en: 1, un: 1, una: 1 };
  var CATS = ['piernas', 'espalda', 'pecho', 'brazos', 'hombros', 'gluteos', 'abdominales', 'cardio', 'racks-jaulas',
    'bancos', 'barras', 'discos-olimpicos', 'maquinas-musculacion', 'accesorios', 'mancuernas-y-kettlebells', 'almacenamiento'];
  var KEY = 'bfIdx3';
  var TTL = 10 * 60 * 1000;
  var CHUNK = 24;
  var RELATED_MAX = 8;
  var indexPromise = null;

  function norm(s) {
    return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, ' ').trim();
  }
  function compact(s) { return norm(s).replace(/ /g, ''); }
  function terms(q) {
    return norm(q).split(' ').filter(function (t) { return t && !STOP[t]; });
  }

  function build(p) {
    var tags = Array.isArray(p.tags) ? p.tags : String(p.tags || '').split(',').map(function (t) { return t.trim(); });
    var cat = null;
    for (var i = 0; i < CATS.length; i++) { if (tags.indexOf(CATS[i]) >= 0) { cat = CATS[i]; break; } }
    var nt = norm(p.title);
    var vars = p.variants || [];
    return {
      id: p.id,
      h: p.handle,
      nt: nt,
      tw: nt.split(' '),
      sk: vars.map(function (v) { return compact(v.sku); }).filter(Boolean),
      tg: tags.map(norm).join(' '),
      cat: cat,
      nac: tags.indexOf('Fabricación nacional') >= 0,
      av: vars.some(function (v) { return v.available; }),
      ty: norm(p.product_type) + ' ' + norm(p.vendor),
      d: norm((p.body_html || '').replace(/<[^>]*>/g, ' ')).slice(0, 500)
    };
  }

  function loadIndex() {
    if (indexPromise) return indexPromise;
    indexPromise = new Promise(function (resolve, reject) {
      try {
        var c = JSON.parse(sessionStorage.getItem(KEY) || 'null');
        if (c && Date.now() - c.t < TTL && c.d && c.d.length) { resolve(c.d); return; }
      } catch (e) { /* sin cache */ }
      var all = [];
      (function next(page) {
        fetch('/products.json?limit=250&page=' + page)
          .then(function (r) { return r.json(); })
          .then(function (j) {
            var ps = j.products || [];
            all = all.concat(ps.map(build));
            if (ps.length === 250) { next(page + 1); return; }
            try { sessionStorage.setItem(KEY, JSON.stringify({ t: Date.now(), d: all })); } catch (e) { /* cuota */ }
            resolve(all);
          })
          .catch(reject);
      })(1);
    });
    return indexPromise;
  }

  function score(p, ts, qc) {
    var s = 0;
    if (qc.length >= 2) {
      for (var i = 0; i < p.sk.length; i++) {
        if (p.sk[i] === qc) return 1000;
        if (p.sk[i].indexOf(qc) === 0) s = Math.max(s, 800);
      }
    }
    if (s) return s;
    if (!ts.length) return 0;
    var ok = ts.every(function (t) {
      return p.tw.some(function (w) { return t.length < 2 ? w === t : w.indexOf(t) === 0; });
    });
    if (!ok) return 0;
    s = 500;
    if (p.nt.indexOf(ts.join(' ')) >= 0) s += 100;
    if (p.av) s += 20;
    if (p.nac) s += 10;
    return s;
  }

  function overlap(p, ts) {
    var hay = ' ' + p.nt + ' ' + p.tg + ' ';
    return ts.filter(function (t) { return hay.indexOf(' ' + t) >= 0; }).length;
  }

  function run(idx, q) {
    var ts = terms(q);
    var qc = compact(q);
    var exact = idx.map(function (p) { return { p: p, s: score(p, ts, qc) }; })
      .filter(function (x) { return x.s > 0; })
      .sort(function (a, b) { return b.s - a.s || (a.p.nt < b.p.nt ? -1 : 1); })
      .map(function (x) { return x.p; });
    var seen = {};
    exact.forEach(function (p) { seen[p.id] = 1; });

    var rel = [];
    var top = exact[0];
    var skuHit = !!top && qc.length >= 2 && top.sk.some(function (s) { return s.indexOf(qc) === 0; });
    if (!skuHit && top && top.cat) {
      rel = idx.filter(function (p) { return !seen[p.id] && p.cat === top.cat; });
    }
    if (!skuHit && rel.length < RELATED_MAX && ts.length) {
      var have = {};
      rel.forEach(function (p) { have[p.id] = 1; });
      rel = rel.concat(idx.filter(function (p) { return !seen[p.id] && !have[p.id] && overlap(p, ts) > 0; }));
    }
    var topCat = top && top.cat;
    rel.sort(function (a, b) {
      var ca = a.cat === topCat ? 1 : 0;
      var cb = b.cat === topCat ? 1 : 0;
      return (cb - ca) || (overlap(b, ts) - overlap(a, ts)) || (b.av - a.av) || (a.nt < b.nt ? -1 : 1);
    });
    return { exact: exact, related: rel.slice(0, RELATED_MAX), terms: ts };
  }

  function idQuery(list) {
    return list.map(function (p) { return 'id:' + p.id; }).join(' OR ');
  }

  /* Pide a Shopify las tarjetas nativas de esos productos y las devuelve en el orden de la lista. */
  function cardsFor(list) {
    var chunks = [];
    for (var i = 0; i < list.length; i += CHUNK) chunks.push(list.slice(i, i + CHUNK));
    return Promise.all(chunks.map(function (ch) {
      return fetch('/search?type=product&q=' + encodeURIComponent(idQuery(ch)))
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var d = new DOMParser().parseFromString(html, 'text/html');
          var map = {};
          d.querySelectorAll('li.product-grid__item').forEach(function (li) {
            var a = li.querySelector('a.product-card__link');
            var h = a && a.getAttribute('href').split('/products/')[1];
            if (h) map[h.split('?')[0]] = li;
          });
          return ch.map(function (p) { return map[p.h]; }).filter(Boolean);
        });
    })).then(function (parts) { return [].concat.apply([], parts); });
  }

  /* Predictivo: devuelve "id:1 OR id:2..." con los exactos, o null para usar la busqueda amplia. */
  function predictiveQuery(q) {
    return loadIndex().then(function (idx) {
      var r = run(idx, q);
      if (!r.exact.length) return 'id:0';
      return idQuery(r.exact.slice(0, 8));
    });
  }

  function pendingOff() { document.documentElement.classList.remove('bf-search-pending'); }

  function enhancePage() {
    var q = new URLSearchParams(location.search).get('q');
    var root = document.querySelector('results-list');
    var grid = root && root.querySelector('ul.product-grid');
    if (!q || !root || !grid) { pendingOff(); return; }
    var wrap = root.querySelector('#ResultsList');
    var failsafe = setTimeout(pendingOff, 6000);

    loadIndex().then(function (idx) {
      var r = run(idx, q);
      if (!r.exact.length) {
        root.classList.add('bfNoneFlag', 'bf-search-none');
        if (!wrap) return;
        var empty = document.createElement('div');
        empty.className = 'bf-search-empty';
        var msg = document.createElement('p');
        msg.textContent = 'No encontramos "' + q + '" en el catálogo. Revisá el código o el nombre e intentá de nuevo.';
        var lnk = document.createElement('a');
        lnk.href = '/collections/all';
        lnk.textContent = 'Ver todo el catálogo';
        empty.appendChild(msg);
        empty.appendChild(lnk);
        wrap.parentNode.insertBefore(empty, wrap);
        var nr = document.querySelector('.search-results__no-results');
        if (nr) nr.style.display = 'none';
        return;
      }
      var first = r.exact.slice(0, CHUNK);
      return Promise.all([cardsFor(first), cardsFor(r.related)]).then(function (res) {
        var mainCards = res[0];
        var relCards = res[1];
        if (!mainCards.length) return;

        root.classList.add('bf-search-on');
        grid.innerHTML = '';
        mainCards.forEach(function (li) { grid.appendChild(document.importNode(li, true)); });

        var count = document.createElement('p');
        count.className = 'bf-search-count';
        count.textContent = r.exact.length + (r.exact.length === 1 ? ' resultado' : ' resultados') + ' para "' + q + '"';
        if (wrap) wrap.parentNode.insertBefore(count, wrap);

        var shown = first.length;
        if (r.exact.length > shown) {
          var more = document.createElement('button');
          more.type = 'button';
          more.className = 'bf-search-more';
          more.textContent = 'Mostrar más resultados';
          more.addEventListener('click', function () {
            more.disabled = true;
            cardsFor(r.exact.slice(shown, shown + CHUNK)).then(function (cards) {
              cards.forEach(function (li) { grid.appendChild(document.importNode(li, true)); });
              shown += CHUNK;
              if (shown >= r.exact.length) more.remove(); else more.disabled = false;
            });
          });
          grid.parentNode.appendChild(more);
        }

        if (relCards.length && wrap) {
          var sec = document.createElement('section');
          sec.className = 'bf-related';
          var h = document.createElement('h2');
          h.className = 'bf-related__title';
          h.textContent = 'También te puede interesar';
          var ul = document.createElement('ul');
          ul.className = grid.className;
          relCards.forEach(function (li) { ul.appendChild(document.importNode(li, true)); });
          sec.appendChild(h);
          sec.appendChild(ul);
          wrap.appendChild(sec);
        }
      });
    }).catch(function () { /* queda la busqueda nativa */ })
      .then(function () { clearTimeout(failsafe); pendingOff(); });
  }

  function killInfinite() {
    document.querySelectorAll('results-list [ref="viewMoreNext"], results-list [ref="viewMorePrevious"]').forEach(function (e) { e.remove(); });
  }
  if (location.pathname.replace(/\/$/, '').split('/').pop() === 'search') {
    killInfinite();
    document.addEventListener('DOMContentLoaded', killInfinite);
  }

  window.bfSearch = { run: function (q) { return loadIndex().then(function (i) { return run(i, q); }); }, predictiveQuery: predictiveQuery, load: loadIndex };

  if (location.pathname.replace(/\/$/, '').split('/').pop() === 'search') {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', enhancePage);
    else enhancePage();
  } else {
    // precarga liviana del indice cuando el navegador esta inactivo, para que el predictivo responda rapido
    (window.requestIdleCallback || function (f) { setTimeout(f, 2500); })(function () { loadIndex().catch(function () {}); });
  }
})();
